// @ts-nocheck
import genRequest from "includes/request";

class GroupObject {
	#id = null;
	#groupName = null;
	#companyId = null;
	#groupDescription = null;
	#defaultHexaColor = null;
	#lastChangeAuthorId = null;
	#lastChanged = null;

	#linkTo = [];
	#dupGroupsPosts = [];

	constructor (props) {
		this.#id = (props?.id ? props.id : null);
		this.#groupName = (props?.groupName ? props.groupName : "");
		this.#companyId = (props?.companyId ? props.companyId : null);
		this.#groupDescription = (props?.groupDescription ? props.groupDescription : "");
		this.#defaultHexaColor = (props?.defaultHexaColor ? props.defaultHexaColor : null);
		this.#lastChangeAuthorId = (props?.lastChangeAuthorId ? props.lastChangeAuthorId : null);
		this.#lastChanged = (props?.lastChanged ? props.lastChanged : null);
		this.#linkTo = (props?.linkTo ? props?.linkTo : []);
		this.#dupGroupsPosts = (props?.dupGroupsPosts ? props?.dupGroupsPosts : []);
	}

	fetchUsers = () => {
		if (!this.#id)
			return (Promise.resolve([]));
		return (genRequest("groups/" + this.#id + "/members"));
	};

	send = () => {
		let that = this;
		let prom = new Promise((resolve, reject) => {
			try {
				that.sendGroup()
					.then(() => {
						return (that.linkUsers());
					}, reject).then(() => {
						return (that.linkPostsFromGroups());
					}, reject).then(() => {
						resolve (that.values());
						return (true);
					});
			} catch (e) {
				reject (e);
				return (false);
			}
		});
		return (prom);
	};

	sendGroup = () => {
		let data = {
			groupName: this.#groupName,
			groupDescription: this.#groupDescription,
			defaultHexaColor: this.#defaultHexaColor,
			companyId: this.#companyId,
		};
		let req = genRequest(
			"groups" + (this.#id ? "/" + this.#id : ""),
			data,
			(this.#id ? "put" : "post")
		).then((resp) => {
			if (!this.#id)
				this.#id = resp.id;
		});
		return (req);
	};

	linkUsers = () => {
		let that = this;
		let prom = new Promise((resolve, reject) => {
			try {
				this.unlinkEmployes().then(() => {
					if (!this.#linkTo?.length)
						return (Promise.resolve());
					let proms = that.#linkTo.map(a => this.linkUser(a.employeeId || a.id));
					return (Promise.all(proms));
				}, reject).then(() => {
					resolve (that.values());
					return (true);
				}, reject);
			} catch (e) {
				reject (e);
				return (false);
			}
		});
		return (prom);
	};

	linkUser = (userId) => genRequest(
		"groups/" + this.#id + "/members/" + userId,
		null,
		"post"
	);

	linksTo = (links) => {
		if (typeof links !== "undefined")
			this.#linkTo = links;
		return (this.#linkTo);
	};

	unlinkEmployes = () => {
		if (!this.#id)
			return (Promise.resolve());
		return genRequest("groups/" + this.#id + "/members").then((members) => {
			if (!members?.length) return;
			let proms = members.map((m) =>
				genRequest(
					"groups/" + this.#id + "/members/" + (m.employeeId || m.id),
					null,
					"delete"
				)
			);
			return Promise.all(proms);
		});
	};

	setDupGroups = (groups) => {
		if (typeof groups !== "undefined")
			this.#dupGroupsPosts = groups;
		return (this.#dupGroupsPosts);
	};

	// "Reprendre les publications d'autres groupes": the posts targeted to the
	// chosen groups are also targeted to this one.
	linkPostsFromGroups = () => {
		let groupIds = this.#dupGroupsPosts
			.map((g) => (typeof g === "object" ? g.id ?? g.value ?? g.groupId : g))
			.filter((id) => Number.isInteger(id));
		if (!this.#id || !groupIds.length)
			return (Promise.resolve());
		return genRequest(
			"groups/" + this.#id + "/copy-posts",
			{ sourceGroupIds: groupIds },
			"post"
		);
	};

	groupId = (setValue) => {
		if (typeof setValue !== "undefined")
			this.#id = setValue;
		return (this.#id);
	};

	name = (setValue) => {
		if (typeof setValue !== "undefined")
			this.#groupName = setValue;
		return (this.#groupName);
	};

	companyId = (setValue) => {
		if (typeof setValue !== "undefined")
			this.#companyId = setValue;
		return (this.#companyId);
	};

	description = (setValue) => {
		if (typeof setValue !== "undefined")
			this.#groupDescription = setValue;
		return (this.#groupDescription);
	};

	defaultHexaColor = (setValue) => {
		if (typeof setValue !== "undefined")
			this.#defaultHexaColor = setValue;
		return (this.#defaultHexaColor);
	};

	lastChangeAuthorId = (setValue) => {
		if (typeof setValue !== "undefined")
			this.#lastChangeAuthorId = setValue;
		return (this.#lastChangeAuthorId);
	};

	lastChanged = (setValue) => {
		if (typeof setValue !== "undefined")
			this.#lastChanged = setValue;
		return (this.#lastChanged);
	};

	values = () => ({
		id: this.#id,
		groupName: this.#groupName,
		companyId: this.#companyId,
		groupDescription: this.#groupDescription,
		defaultHexaColor: this.#defaultHexaColor,
		lastChangeAuthorId: this.#lastChangeAuthorId,
		lastChanged: this.#lastChanged
	});
}

export default GroupObject;
